import { loadGlobalScript } from './load-global';

import jqueryUi from './jquery-ui.js?raw';
import bootstrap from './bootstrap.bundle.min.js?raw';
import waves from './waves.min.js?raw';
import slimscroll from './jquery.slimscroll.min.js?raw';

import select2 from './plugins/select2/select2.min.js?raw';
import datepicker from './plugins/bootstrap-datepicker/bootstrap-datepicker.min.js?raw';
import datepickerIt from './locales/bootstrap-datepicker.it.js?raw';

import dataTables from './plugins/datatables/jquery.dataTables.min.js?raw';
import dtBs4 from './plugins/datatables/dataTables.bootstrap4.min.js?raw';
import dtButtons from './plugins/datatables/dataTables.buttons.min.js?raw';
import dtButtonsBs4 from './plugins/datatables/buttons.bootstrap4.min.js?raw';
import jszip from './plugins/datatables/jszip.min.js?raw';
import pdfmake from './plugins/datatables/pdfmake.min.js?raw';
import vfsFonts from './plugins/datatables/vfs_fonts.js?raw';
import dtHtml5 from './plugins/datatables/buttons.html5.min.js?raw';
import dtPrint from './plugins/datatables/buttons.print.min.js?raw';
import dtColVis from './plugins/datatables/buttons.colVis.min.js?raw';

import nestable from './plugins/nestable/jquery.nestable.min.js?raw';
import magnific from './plugins/magnific-popup/jquery.magnific-popup.min.js?raw';
import repeater from './jquery.repeater.min.js?raw';
import formRepeater from './jquery.form-repeater.js?raw';

import sweetalert2 from './plugins/sweet-alert2/sweetalert2.all.js?raw';
import parsley from './plugins/parsleyjs/parsley.min.js?raw';
import parsleyEn from './locales/parsley-en.js?raw';
import parsleyIt from './locales/parsley-it.js?raw';

import dmUploader from './plugins/dm-uploader/jquery.dm-uploader.min.js?raw';
import tagify from './jquery.tagify.min.js?raw';
import spectrum from './plugins/spectrum-colorpicker2/spectrum.min.js?raw';

import videojs from './plugins/videojs/video.min.js?raw';
import videojsYoutube from './plugins/videojs/youtube.js?raw';
import vimeo from './plugins/vimeo/player.js?raw';

import selectize from './plugins/selectize/selectize.js?raw';

[
  jqueryUi, bootstrap, waves, slimscroll,
  select2, datepicker, datepickerIt,
  dataTables, dtBs4, dtButtons, dtButtonsBs4,
  jszip, pdfmake, vfsFonts, dtHtml5, dtPrint, dtColVis,
  nestable, magnific, repeater, formRepeater,
  sweetalert2, parsley, parsleyEn, parsleyIt,
  dmUploader, tagify, spectrum,
  videojs, videojsYoutube, vimeo,
  selectize,
].forEach(loadGlobalScript);